module Meevo.Plugins.MarketPricing {
    "use strict";

    import IPagedResultsColumns = Meevo.Components.BaseClasses.IPagedResultsColumns;
    import IPagerModel = Meevo.Plugins.MarketPricing.IPagerModel;

    export class SwapGroupsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<IPagerModel> {
        public filterCriteria: any = {
            priceGroupId: ''
        };
        public defaultCriteria() {
            return this.filterCriteria;
        }

        constructor(protected params: Meevo.Model.ISectionParamsBaseDataService) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings,
                params.sectionSecurityKey
            );
        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.sectionModelRetrieved();
            this.takeBackup();
        }

        /**
         * When tab is activated
         * */
        public sectionModelRetrieved(): void {
            this.filterCriteria.priceGroupId = this.parentItemId;
        }

        /**
         * When tab is lefted
         */
        public prevUnselected(): void {
            // Rollback sectionEndpoint
            this.sectionEndpoint = '';

            super.prevUnselected();
        }

        /**
        * Restores the original model values which were stored at the time of load.
        * @returns {}
        */
        rollbackChanges(): void {
            _.extend(this.model, this.originalEntity);

            this.sectionModelRetrieved();
        }

        /**
         * Save
         * */
        public preSave(): any {
            let currentPage = this.model.pages[this.model.currentPage];
            let originalEntity = this.originalEntity;
            let originalCurrentPage = originalEntity.pages[this.model.currentPage];
            let save = {
                swapGroupServices: []
            };

            this.sectionEndpoint = 'SwapGroup';

            // Find changed items
            _.each(currentPage, (el: any, index) => {
                let originalElement = originalCurrentPage[index];

                _.each(el.services, (service: any, index) => {
                    let originalService = originalElement.services[index];

                    if (service.additionalCost !== originalService.additionalCost) {
                        save.swapGroupServices.push({
                            swapGroupServiceId: service.swapGroupServiceId,
                            swapGroupServiceName: service.serviceDisplayName,
                            serviceShortCut: service.serviceShortCut,
                            additionalCost: service.additionalCost,
                            oldAdditionalCost: originalService.additionalCost
                        });
                    }
                });
            });

            this.model = <IPagerModel>save;
        }
    }
}